module.exports = __webpack_public_path__ + "static/media/edit-image.3777c04d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/edit-image.svg
// module id = 741
// module chunks = 0